var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "head-cart", class: { opened: _vm.open } }, [
    _c("div", { staticClass: "head-cart-container" }, [
      _c("div", { staticClass: "head-cart-title" }, [
        _vm._v("\n            " + _vm._s(_vm.strings["shopping_bag"]) + " "),
        _c(
          "span",
          {
            staticClass: "close-panel",
            attrs: { id: "close-panel" },
            on: {
              click: function($event) {
                return _vm.$emit("close-cart")
              }
            }
          },
          [_c("i", { staticClass: "fal fa-times" })]
        )
      ]),
      _vm._v(" "),
      _vm.loading === false && _vm.empty != false
        ? _c(
            "div",
            {
              staticClass: "head-cart-empty-message",
              class: { empty: _vm.empty === true || _vm.empty === null }
            },
            [_vm._v(_vm._s(_vm.strings["empty_cart"]))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading === false && _vm.empty == false
        ? _c(
            "div",
            {
              staticClass: "head-cart-items-content-list",
              class: { show: _vm.empty === false }
            },
            [
              _c(
                "div",
                { staticClass: "head-cart-items-list" },
                _vm._l(_vm.cart.items, function(product, key) {
                  return _c("cart-item", {
                    key: key,
                    attrs: {
                      product: product,
                      currency: _vm.cart.currency,
                      strings: _vm.strings
                    },
                    on: {
                      remove: function($event) {
                        return _vm.$emit("remove-item", key)
                      }
                    }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "head-cart-totals text-right" }, [
                _c(
                  "div",
                  {
                    staticClass: "head-cart-totals-subtotal row",
                    class: { "head-cart-totals-total": !_vm.cart.promoCheck }
                  },
                  [
                    _c("div", { staticClass: "col-xs-5 text-uppercase" }, [
                      _vm._v(_vm._s(_vm.strings["subtotal"]))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-2" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-5" }, [
                      _vm._v(
                        _vm._s(_vm.cart.currency) +
                          " " +
                          _vm._s(_vm.cart.subtotal.toFixed(2))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.cart.promoCheck
                  ? _c(
                      "div",
                      { staticClass: "head-cart-totals-promo-cost row" },
                      [
                        _c("div", { staticClass: "col-xs-5" }, [
                          _vm._v(_vm._s(_vm.cart.promoCode))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-2" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-5" }, [
                          _vm._v(
                            _vm._s(_vm.cart.currency) +
                              " - " +
                              _vm._s(_vm.cart.subtotalPromo.toFixed(2))
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.cart.promoCheck
                  ? _c("div", { staticClass: "head-cart-totals-total row" }, [
                      _c("div", { staticClass: "col-xs-5" }, [
                        _vm._v(
                          _vm._s(_vm.cart.currency) +
                            " " +
                            _vm._s(_vm.strings["total"])
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-5" }, [
                        _vm._v(
                          _vm._s(_vm.cart.currency) +
                            " " +
                            _vm._s(_vm.cart.totalOutShippingCost.toFixed(2))
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.shippingrussian === true
                  ? _c("div", { staticClass: "head-cart-totals-info row tr" }, [
                      _c("div", {
                        staticClass: "col-xs-12",
                        domProps: {
                          innerHTML: _vm._s(_vm.strings["shipping_russian"])
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.activebuy === false
                  ? _c("div", { staticClass: "head-cart-totals-info row tr" }, [
                      _c("div", { staticClass: "col-xs-12" }, [
                        _vm._v(_vm._s(_vm.strings["minimum_order_gb"]))
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.activebuy === true
                ? _c("div", { staticClass: "head-cart-action-btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: _vm.api["summary"] }
                      },
                      [_vm._v(_vm._s(_vm.strings["go_to_checkout"]))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "mt3 btn btn-white",
                        attrs: { href: _vm.api["go_to_cart"] }
                      },
                      [_vm._v(_vm._s(_vm.strings["go_to_cart"]))]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading === true
        ? _c("div", { staticClass: "tc head-cart-loading" }, [_vm._m(0)])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head-cart-loading-flex" }, [
      _c("div", { staticClass: "loader" }, [_vm._v("Loading...")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }